var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "url(#pattern0_173_944)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_173_944",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_173_944",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_173_944",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADuklEQVR4nO2dz4sURxzFSyTGQyIYBfMDcwhECNHT3paZfq+nx80IOTr/QMQQSO6CggqCB/HiKYQgEggJLLknh0AOUU8mKq6bH+JBQ3JN9pJLJC3FFMiITjtr//hWzfvAu+3M1qvP9Ex3T0+Xc0IIIYQQQgixoAwGgz0AjgK4QPJrkqsd56vhcPimWzQA7Cb5Kcn/SJaWAuBuv9/f6xaFLMve8aW7nnjOzp3BYPCGW5C3qHsGJrx8hvyevBQA3xiY6HIeKcPh8HWXIlmWHSD5v4FJLufMut+yXWqQPGNgcsvNBMCv/X7/NZcSJL/temL5fPkFwKsuFUj+XPEqvN3BccfVObeUm36X3aUAgLWKsqc7GNN4E29fN4qi2OViJxUhnOR69FISE1J6KSsrK6+4WElQSOk/F6OVkqiQEsBPvV5vp4uNVIVwkquj0WiHi4nEhZQAriwvL7/sYiF1IZx0uNyZlCzLDpK85E+lA7hW9feLIISTHG+1hD8lDeD7xyZzrepxiyIEbfYoimIfgD+fMAgJYcs9/F4EgN+eMggJYcs9Zp0+j1VIr9fbmef50jyp+vq5lR7j8XgbgH9SE7IZTPQIe1SzBiEhbLEHyY8lxFAPkiclxFAP/08kxFAPCTHWQ0KM9bAgBJPrgY81nCNN90hGSJ7n7856fB2JZkuXkEdISEBCpgchIQEJCUjI9CAkJCAhAQkxJqQoirf8d/dNxl+A3XSPZIRYwUQPCTHWQ0KM9ZAQYz0sCMm1lzU1CAkJSEhAQqYHISEBCQlIyPQgJCQgIQEJmR6EhAQkZPrq+3GTIfmeq0BCjGGih4QY6yEhxnpIiLEeEmKsh4QY6yEhCQoheWvWc5Bcbfo4o6ZjlfsVPU7GIuSHiiJlCgHwURRCAHzW9WSxheR5PohFyPtdTxabz99LS0svRCFkPB5vfYbPkTLynGpcRl1CPCRhcUUE1pN1AC9FJcTjfzYG4IGBCSxrzB9Zlr3t2qJOIR5/mjuiVRLKiu7ftX4b8rqFhOfcnuf5h/4W5P6WTxFtNf/69UUAXGxlj6otIeI5kBBjSIgxJMQYEmIMCTGGhBhDQozh79ZcIWTDwLKpq/MGwCcuRvI8/8DAEXLZQM65GAGw38DklXUHwGEXK2EVtZRkbES1vMTj+FdT15PIenPCxQ7JzxPZOq6MRqMXXez4EmEh+jLi/JjM4pCBLQCOkvwrsq1iw79N+fvYuxTxW0uWZYdIngXwhdHjjC8BnA8XubXzfbcQQgghhBBCOPs8BKnr6SLqp0HsAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandards);
export default __webpack_public_path__ + "static/media/standards.fb36506ec1b9192a199ed2888f7a35be.svg";
export { ForwardRef as ReactComponent };